import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";

import { ConfigService } from "@shared/utils/config.service";

import { BaseService } from "@core/services/base.service";

import { Observable } from "rxjs/Rx";


//import * as _ from 'lodash';

// Add the RxJS Observable operators we need in this app.
import "../../../rxjs-operators";
import { State } from "@shared/models";

@Injectable()
export class LocationsService extends BaseService {
  baseUrl: string = "";

  constructor(private http: Http, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  getServerDate(): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .get(
        this.baseUrl + "/locations/dataAtual",
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  listUFBySectorAndSeller(setor, vendedor): Observable<State[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    let params = {
      setor: setor,
      nomeVendedor: vendedor,
    }

    return this.http
      .get(
        this.baseUrl + "/locations/listUFBySectorAndSeller",
        { headers, params }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }
}
